import React from "react";
import Link from "next/link";
import Arrow from "./svgs/arrow.svg";

const ArrowLink = ({ href, text, className }: { href?: string; text: string; className?: string }) => {
	if (!href) return null;
	return (
		<Link href={href} className={`group flex items-center gap-6 ${className}`}>
			<Arrow className="text-pink group-hover:text-yellow stroke-navy w-[2.375rem] fill-transparent duration-500" />
			{text}
		</Link>
	);
};

export default ArrowLink;
